/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */
import { Component, OnInit } from '@angular/core';
import { MenuService } from '@app/core/menu/menu.service';
import { AuthenticationService, Logger } from '@app/core';
import { MenuItem } from '@app/shared/models/menu-item.model';
import { ProfileService } from '@app/profile/profile.service';
import { NgScrollbarModule } from 'ngx-scrollbar';

const log = new Logger('SideMenuComponent');

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent implements OnInit {
  menuFolded = false;
  menuNeedClose = false;
  isUserLoggedIn = false;
  AuthenticationService = AuthenticationService;
  menu: Array<MenuItem> = [];

  constructor(
    private authenticationService: AuthenticationService,
    public menuService: MenuService,
    public profileService: ProfileService
  ) {}

  ngOnInit() {
    this.isUserLoggedIn = this.authenticationService.isAuthenticated();
    this.menu = this.menuService.getItems();
    this.menu.forEach((menuItem: MenuItem) => {
      menuItem.collapsed = this.profileService.getSetting(menuItem.key, 'menuCollapsableItems');
    });
  }

  toggleMenu() {
    this.menuFolded = !this.menuFolded;
    this.toggleBodyClass();
  }
  toggleBodyClass() {
    if (this.menuFolded) {
      document.body.classList.add('menu-folded');
    } else {
      document.body.classList.remove('menu-folded');
    }
  }

  mouseEnter() {
    if (this.menuFolded) {
      this.menuFolded = false;
      this.menuNeedClose = true;
    }
  }

  mouseleave() {
    if (this.menuNeedClose) {
      this.menuFolded = true;
      this.menuNeedClose = false;
    }
  }

  toggleCollapsableItems(item: MenuItem) {
    item.collapsed = !item.collapsed;
    this.profileService.setSetting(item.key, item.collapsed, 'menuCollapsableItems').subscribe();
  }
}
